export default __webpack_public_path__ + "static/images/idol_icon_rose.jpg";